export default __webpack_public_path__ + "static/media/alertGreen.f90ea55d.svg";